const PageContainer = ({
  children,
  title,
  subtitle,
  className = '',
  titleClassName = 'text-text-dark',
  subtitleClassName = 'text-text-secondary',
}) => {
  return (
    <div className={`p-4 md:p-6 flex-1 ${className}`}>
      {(title || subtitle) && (
        <div className="mb-4 md:mb-6">
          {title && <h1 className={`text-2xl md:text-3xl font-bold mb-1 ${titleClassName}`}>{title}</h1>}
          {subtitle && <p className={`text-sm md:text-base ${subtitleClassName}`}>{subtitle}</p>}
        </div>
      )}
      {children}
    </div>
  )
}

export default PageContainer
